"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import logger from "@/utils/logger";

const endpointBasePrefix = "pos_terminals";

const Model = {
	namespace: "m_PosTerminals",
	state: {
		posTerminals: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { posTerminals } }) {
			return { ...state, posTerminals };
		},
	},
	effects: {
		*fetchAll({ brandId, outletId, scopeToken, saveToState = true }, { call, put }) {
			let posTerminals = yield call(svc_search, endpointBasePrefix, { brand: brandId, outlet: outletId });

			_.forEach(posTerminals, function (row) {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["enrolment_date"]);
				if (outletId && !scopeToken.allowedDerivedOutlets.includes(outletId)) row.disableEdit = true;
				if (brandId && !outletId && !scopeToken.allowedBrands.includes(brandId)) row.disableEdit = true;
			});

            if (saveToState) {
                yield put({
                    type: "handleFetchAll",
                    payload: { posTerminals },
                });
            }

			return posTerminals;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
